module.exports = __webpack_public_path__ + "img/France_3_-_logo_2018.66829ae2.svg";